"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class ProductFeaturedMetaFieldArticleController {
    constructor(url, handle, title) {
        // init
        this.init = (title) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.getTSArticle(title);
            if (!res)
                return;
            const parser = new DOMParser;
            const images = this.getDOMImages(parser.parseFromString(res.hits[0].document.body_html_full, "text/html"));
            const section = document.getElementById('productMetaFieldArticleDOMImages');
            if (images.length < 1) {
                section === null || section === void 0 ? void 0 : section.classList.add("collapse");
                return;
            }
            const filteredImages = this.filterDOMProductImages(images);
            const placeholderWrapper = section === null || section === void 0 ? void 0 : section.querySelectorAll('.placeholder');
            filteredImages.forEach((el, ind) => {
                if (ind >= 0 && ind <= 15) {
                    const imgElm = this.getImageElm(el.src);
                    // console.log(el.src)
                    imgElm.addEventListener('click', () => {
                        MoobiUtilities.renderOverlayExternalCover({ externalSection: this.getEnlargedImageElm(el.src) });
                    });
                    section === null || section === void 0 ? void 0 : section.insertAdjacentElement('beforeend', imgElm);
                }
            });
            placeholderWrapper === null || placeholderWrapper === void 0 ? void 0 : placeholderWrapper.forEach((el) => { el.remove(); });
        });
        // API calls
        this.getTSArticle = (title) => __awaiter(this, void 0, void 0, function* () {
            const options = {
                q: title,
                qby: "title",
                filterBy: undefined,
                filterString: undefined,
                facetby: undefined,
                pageNo: 1,
                perPage: 1,
            };
            const res = yield extendedTSClient.searchArticleColZH01(options);
            return res;
        });
        // process call data
        this.getDOMImages = (doc) => {
            const images = Array.from(doc.querySelectorAll('img'));
            const filteredImages = this.filterDOMProductImages(images);
            return filteredImages.map((el) => { return el; });
        };
        this.filterDOMProductImages = (images) => {
            const filteredImages = images.filter((el) => {
                return !el.src.includes("product");
            }).filter((el_01) => {
                return !el_01.src.includes("width");
            });
            return filteredImages;
        };
        // render DOM
        this.getImageElm = (src) => {
            const img = Object.assign(document.createElement('img'), { src });
            const wrapper = Object.assign(document.createElement('div'), { classList: "imageWrapper imageSkeleton" });
            wrapper.insertAdjacentElement('beforeend', img);
            return wrapper;
        };
        this.getEnlargedImageElm = (src) => {
            const img = Object.assign(document.createElement('img'), { src });
            const wrapper = Object.assign(document.createElement('div'), { classList: "enlargedArticleImageWrapper" });
            wrapper.insertAdjacentElement('beforeend', img);
            return wrapper;
        };
        this.articleUrl = url;
        this.articleHandle = handle;
        this.articleTitle = title;
        this.init(title);
    }
}
// create instance
ProductFeaturedMetaFieldArticleController.createInstance = () => {
    const section = document.getElementById("featuredMetaArticle");
    if (!section)
        return;
    const { url, title, handle } = { url: section.dataset.url, title: section.dataset.title, handle: section.dataset.handle };
    return new ProductFeaturedMetaFieldArticleController(url, handle, title);
};
const productFeaturedMetaFieldArticle = ProductFeaturedMetaFieldArticleController.createInstance();
